import { Cancel, Replay } from '@mui/icons-material';
import { MenuItem, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';

const FailedPostNestedGridActionPopup = ({ popoverElement, handleCloseMenu, retryNow }) => {
  const { t: translate } = useTranslation();
  return (
    <Popover
      open={Boolean(popoverElement)}
      anchorEl={popoverElement}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: { p: 1, width: 170, '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 } },
      }}
    >
      {' '}
      <MenuItem sx={{ color: 'error.main' }} onClick={retryNow}>
        <Replay sx={{ mr: 1 }} /> {translate("failed_post.retry_now")}
      </MenuItem>
    </Popover>
  );
};
export default FailedPostNestedGridActionPopup;
